import React, { useCallback, useEffect } from "react";
import ReactDOM from "react-dom";
import "./ConfirmModal.css";
import Button from "../Buttons/Button/Button";
import ButtonClose from "../Buttons/ButtonClose/ButtonClose";

export default function ConfirmModal({
  isOpen,
  title = "Confirm action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
  showCancel = true,
  confirmVariant = "destructive",
  cancelVariant = "secondary",
  showCloseIcon = true,
  showFooter = true,
  bodyCenter = false,
}) {
  const handleOverlayClick = useCallback((e) => {
    if (e.target === e.currentTarget) {
      onCancel?.() || onConfirm?.();
    }
  }, [onCancel, onConfirm]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onCancel?.() || onConfirm?.();
    }
  }, [onCancel, onConfirm]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.body.style.overflow = 'unset';
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;
  
  return ReactDOM.createPortal(
    <div 
      className="confirm-modal-overlay" 
      role="dialog" 
      aria-modal="true"
      onClick={handleOverlayClick}
    >
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-header">
          <h3 className="confirm-modal-title">{title}</h3>
          {showCloseIcon && (
            <ButtonClose
              onClick={onCancel || onConfirm}
              ariaLabel="Close"
              className="confirm-modal-close"
            />
          )}
        </div>
        <div className={`confirm-modal-body${bodyCenter ? " confirm-modal-body-center" : ""}`}>
          <p>{message}</p>
        </div>
        {showFooter && (
          <div className="confirm-modal-footer">
            {showCancel && (
              <Button
                variant={cancelVariant}
                size="md"
                onClick={onCancel}
                disabled={loading}
              >
                {cancelText}
              </Button>
            )}
            <Button
              variant={confirmVariant}
              size="md"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? "Processing…" : confirmText}
            </Button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
